import React, { useEffect, useState } from "react";
import { liteClient as algoliasearch } from "algoliasearch/lite";
import { InstantSearch, useSearchBox, Configure } from "react-instantsearch";
import { Input } from "components/Input";
import { Results } from "components/layout/Search";

import * as styles from "./Search.module.scss";
import { ScrollArea } from "../../ScrollArea";

const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID as string,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY as string,
);
import { ReactComponent as ClearIcon } from "assets/icons/icon-close-2.svg";
import { AnimatePresence, motion } from "framer-motion";
import cx from "classnames";

const searchClient = algoliaClient;

const Search = () => {
  return (
    <InstantSearch
      indexName={`matches`}
      searchClient={searchClient}
      future={{
        preserveSharedStateOnUnmount: true,
      }}
    >
      <Configure hitsPerPage={8} />
      <SearchBox />
      <ScrollArea
        className={styles.scrollArea}
        thumbClassName={styles.scrollThumb}
        hideHorizontalScrollbar
      >
        <Results />
      </ScrollArea>
    </InstantSearch>
  );
};

const SearchBox = () => {
  const { query, refine } = useSearchBox();
  const [queryString, setQueryString] = useState(query);

  useEffect(() => {
    if (query !== queryString) {
      setQueryString(query);
    }
  }, [query]);

  const setQuery = (str: string) => {
    setQueryString(str);
    refine(str);
  };

  return (
    <div className={styles.searchBox}>
      <Input
        containerClassName={styles.searchInputContainer}
        wrapperClassName={cx(styles.searchInput, {
          [styles.hasQuery]: !!query,
        })}
        value={queryString}
        autoFocus
        placeholder="Enter search term"
        onChange={(e) => setQuery(e.currentTarget.value)}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="none"
        spellCheck="false"
        icon={
          <AnimatePresence>
            {!!query && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <span onClick={() => setQuery("")} className={styles.clearIcon}>
                  <ClearIcon />
                </span>
              </motion.div>
            )}
          </AnimatePresence>
        }
      />
    </div>
  );
};

export { Search };
